function regionFadeOut(region) {
    $('#' + region).fadeOut();
    $('#' + region + 'list').fadeOut();
    $('#regionhover').hide();
};

var regionMap = function () {
    $('#regionmap area').each(function () {
        $('#' + $(this).data('region')).css('display', 'none');

        $(this).mouseenter(function () {
            var region = $(this).data('region');
            $('#' + region).css('display', 'block');

            $('#' + region + 'list').css('display', 'block');

            clearTimeout(regionTimeouts[region]);
        });

        $(this).mouseleave(function () {
            var region = $(this).data('region');
            regionTimeouts[region] = setTimeout("regionFadeOut('" + region + "')", 300);
        });

        $(this).click(function (event) {
            event.preventDefault();
        });
    });

    var regionhover = $('#regionhover');
    $('ul.sections a').each(function () {
        $(this).mouseenter(function () {
            var dataregion = $(this).data('region');

            if (dataregion != '') {
                if (dynamicrequest) {
                    dynamicrequest.abort();
                }

                dynamicrequest = $.ajax({
                    type: 'GET',
                    url: '/inc/regions.php',
                    data: 'region=' + dataregion,
                    success: function (response) {
                        regionhover.html(response);
                        regionhover.fadeTo(300, 1);

                        //$('#regionpopfade').slick('unslick');
                        $('#regionpopfade').slick({
                            infinite: true,
                            dots: false,
                            arrows: false,
                            autoplay: true,
                            autoplaySpeed: 1500
                        });
                    }
                });
            }
        });
    });


    $('ul.sections').each(function () {
        $(this).css('display', 'none');

        var region = $(this).data('region');

        $(this).mouseenter(function () {
            clearTimeout(regionTimeouts[region]);
        });

        $(this).mouseleave(function () {
            regionTimeouts[region] = setTimeout("regionFadeOut('" + region + "')", 300);
        });
    });
};

new regionMap();